<template>
  <div>
	  <div v-if="$route.path.indexOf('mh5') > -1 "  >
		  <router-view    />
		  <van-tabbar v-if="judgePcOrAndirodCopy()"  v-model="active" active-color="#409eff" @change="changePage()" inactive-color="#000">
				<van-tabbar-item icon="wap-home-o">{{$t('other.a339')}}</van-tabbar-item>
				<van-tabbar-item icon="bag-o">{{$t('other.a340')}}</van-tabbar-item>
				<van-tabbar-item icon="contact">{{$t('other.a341')}}</van-tabbar-item>
			</van-tabbar>
	  </div>
	  <div v-else>
		<Header v-if="!$route.meta.showHeaderAside"  v-show="!(path == '/privacy' ||  path == '/lazadaStockList' || path == '/productAndPicklist' || path == '/productStockling' || path == '/pickinglistCopy' || path === '/productPicklist' || path ===  '/loginToken' || path ===  '/orderAndpicklist'|| path === '/signOrder' || path === '/stockingList' || path === '/registorpage' || path === '/registor' || path === '/sealpage' || path === '/newPage' || path === '/orderpage' || path === '/printpage' || path === '/pickinglist' || path ==='/loginPage' || path ==='/personal'  || path ==='/personal-account' || path ==='/personal-info')"  />
		<div class="main" >
			<Aside v-show="ttbv() "  v-if="!$route.meta.showHeaderAside" />
			<div :class="{'tipbf':isCollapse == false && ttbv(),'kvbn':isCollapse && ttbv(),'bkjm':$route.meta.showHeaderAside}"> 
				<keep-alive>
					<router-view   v-if="$route.meta.keepAlive"  />
				</keep-alive>
				<router-view       v-if="!$route.meta.keepAlive"  />
			</div>
		</div>
		<div class="service-body" @click="todischat" v-show="!(path == '/servicechat' || path == '/iddstation')" id="carMessage" @mousedown='draggableFun($event)'>
			<div><img src="../assets/img/ss1.png" alt="" style="width:40px;height:40px"></div>
			<div class="ser-div">
			<el-badge :value="valnum" class="item"  :hidden="valchcke">
			</el-badge></div>
		</div>
		
	  </div>
		<el-dialog
		:visible.sync="dialogVisible"
		width="70%"
		:before-close="handleClose">
		<DisChat></DisChat>
		</el-dialog>
  </div>
</template>

<script>
export default {
data(){
return{

}
},
create(){

},
methods:{

}
}

</script>
<style scoped>
</style>